<template>
    <div>
        <fieldset :disabled="formDisabled">
            <loader v-show="isLoading" />
            <form class="form-horizontal" v-on:submit.prevent data-vv-scope="rockArtForm" id="rockArtForm" v-show="!isLoading">
                <div class="row">
                    <div class="col-sm-3">
                        <h4>Panel {{rockArtPanelDto.panelNumber}} of {{rockArtCount}} </h4>
                    </div>
                    <div class="col-sm-4">
                        <label>Panel ID:</label> {{rockArtPanelDto.dbNumber}}
                    </div>
                </div>
                <div v-if="qaqcEnabled" class="row" style="margin-bottom: 20px;">
                    <label class="col-md-3">Production Panel Selection:</label>
                    <div class="col-md-7">
                        <select class="form-control" v-model="qaqcSelection.panelSelection">
                            <option disabled :value="-1">Panel Selection</option>
                            <option :value="0">Add As New Production Panel</option>
                            <option v-for="panel in productionPanelList" :value="panel.rockArtPanelId">Update Production Panel: {{panel.dbNumber}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.panelAge') }">
                    <label class="col-md-2 control-label text-label">Presumed Age</label>
                    <div class="col-md-4">
                        <select class="form-control" v-model="rockArtPanelDto.panelAgeId" v-validate="'required'" name="panelAge">
                            <option disabled value=''>Select a value</option>
                            <option v-for="age in ageList" :value="age.panelAgeId">
                                {{age.description}}
                            </option>
                        </select>
                        <span v-show="errors.has('rockArtForm.panelAge')" class="has-error">{{ errors.first('rockArtForm.panelAge') }}</span>
                    </div>
                    <div class="col-md-2">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'panelAgeId'" :hasAppend="false"></qaqcFormFieldSelect>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.panelLocation') }">
                    <label class="col-md-2 control-label text-label">Location</label>
                    <div class="col-md-4">
                        <select class="form-control" v-model="rockArtPanelDto.panelLocationId" v-validate="'required'" name="panelLocation">
                            <option disabled value=''>Select a value</option>
                            <option v-for="location in locationList" :value="location.panelLocationId">
                                {{location.description}}
                            </option>
                        </select>
                        <span v-show="errors.has('rockArtForm.panelLocation')" class="has-error">{{ errors.first('rockArtForm.panelLocation') }}</span>
                    </div>
                    <div class="col-md-2">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'panelLocationId'" :hasAppend="false"></qaqcFormFieldSelect>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.placementDescription') }">
                    <label class="col-md-2 control-label text-label">Placement and Distance</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control" v-model="orientationDto.placementDescription" placeholder="Description of Placement and Distance to Surrounding Panels" v-validate="'required'"
                         name="placementDescription" />
                        <span v-show="errors.has('rockArtForm.placementDescription')" class="has-error">{{ errors.first('rockArtForm.placementDescription') }}</span>
                    </div>
                    <div class="col-md-2">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'placementDescription'" :hasAppend="true"></qaqcFormFieldSelect>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.rockType') }">
                    <label class="col-md-2 control-label text-label">Rock Type</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control" v-model="orientationDto.rockType" placeholder="Type of Rock and geological formation" v-validate="'required'"
                         name="rockType" />
                        <span v-show="errors.has('rockArtForm.rockType')" class="has-error">{{ errors.first('rockArtForm.rockType') }}</span>
                    </div>
                    <div class="col-md-2">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'rockType'" :hasAppend="true"></qaqcFormFieldSelect>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.panelAspect') }">
                    <label class="col-md-2 control-label text-label">Panel Aspect</label>
                    <div class="col-md-2">
                        <select class="form-control" v-model="orientationDto.panelAspectId" v-validate="'required'" name="panelAspect">
                            <option disabled value=''>Select a value</option>
                            <option v-for="bearing in compassBearingList" :value="bearing.panelAspectId">
                                {{bearing.description}}
                            </option>
                        </select>
                        <span v-show="errors.has('rockArtForm.panelAspect')" class="has-error">{{ errors.first('rockArtForm.panelAspect') }}</span>
                    </div>
                    <div class="col-md-2">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'panelAspectId'" :hasAppend="false"></qaqcFormFieldSelect>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.eastDegree') }">
                    <label class="col-md-2 control-label text-label">Panel Degrees</label>
                    <div class="col-md-2">
                        <input type="number" class="form-control" v-model="orientationDto.eastDegree" name="eastDegree" v-validate="'required'">
                        <span v-show="errors.has('rockArtForm.eastDegree')" class="has-error">{{ errors.first('rockArtForm.eastDegree') }}</span>
                    </div>
                    <div class="col-md-2">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'eastDegree'" :hasAppend="false"></qaqcFormFieldSelect>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': (errors.has('rockArtForm.heightBottom') || errors.has('rockArtForm.heightTop')) }">
                    <label class="col-md-2 control-label text-label">Height</label>
                    <div class="col-md-10">
                        <label><span>Height of art element(s) from present ground level (in meters)</span></label>
                        <div class="form-group form-inline">
                            <label><span>Lowest</span></label>
                            <input type="number" step="0.01" class="form-control" placeholder="Lowest" v-model="orientationDto.heightBottom" name="heightBottom" v-validate="'required'">
                            <label><span>&nbsp;</span></label>
                            <label><span>Highest</span></label>
                            <input type="number" step="0.01" class="form-control" placeholder="Highest" v-model="orientationDto.heightTop" name="heightTop" v-validate="'required'">
                            <label><span>&nbsp;</span></label>
                            <span v-show="(errors.has('rockArtForm.heightBottom') || errors.has('rockArtForm.heightTop'))" class="has-error">Required</span>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'heightBottom'" :hasAppend="false"></qaqcFormFieldSelect>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': (errors.has('rockArtForm.panelHeight') || errors.has('rockArtForm.panelWidth')) }">
                    <label class="col-md-2 control-label text-label">Panel dimensions</label>
                    <div class="col-md-3">
                        <label><span>Height</span></label>
                        <input type="number" step="0.01" class="form-control" placeholder="Height" v-model="orientationDto.panelHeight" name="panelHeight" v-validate="'required'">
                    </div>
                    <div class="col-md-3">
                        <label><span>Width</span></label>
                        <input type="number" step="0.01" class="form-control" placeholder="Width" v-model="orientationDto.panelWidth" name="panelWidth" v-validate="'required'">
                    </div>
                    <span v-show="(errors.has('rockArtForm.panelHeight') || errors.has('rockArtForm.panelWidth'))" class="has-error">Required</span>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'panelHeight'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': (errors.has('rockArtForm.panelDistance') || errors.has('rockArtForm.panelDegree')) }">
                    <label class="col-md-2 control-label text-label">Site Datum to Panel Datum</label>
                    <div class="col-md-3">
                        <label><span>Meters</span></label>
                        <input  type="number" step="0.01" class="form-control" placeholder="meters" v-model="orientationDto.panelDistance" name="panelDistance" v-validate="'required'">
                    </div>
                    <div class="col-md-3">
                        <label><span>Degrees</span></label>
                        <input  type="number" class="form-control" placeholder="degrees east of north" v-model="orientationDto.panelDegree" name="panelDegree" v-validate="'required'">
                    </div>
                    <span v-show="(errors.has('rockArtForm.panelDistance') || errors.has('rockArtForm.panelDegree'))" class="has-error">Required</span>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'panelDistance'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.archeologicalDeposits') }">
                    <label class="col-md-2 control-label text-label">Associated/nearby archaeological deposits</label>
                    <div class="col-md-2">
                        <select class="form-control" v-model="orientationDto.yesNoArcheologicalDepositsId" name="archeologicalDeposits" v-validate="'required'">
                            <option disabled value=''>Select a value</option>
                            <option value=1>Yes</option>
                            <option value=2>No</option>
                            <option value=3>Unknown</option>
                        </select>
                        <span v-show="errors.has('rockArtForm.archeologicalDeposits')" class="has-error">{{ errors.first('rockArtForm.archeologicalDeposits') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'yesNoArcheologicalDepositsId'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.culturalAffiliation') }">
                    <label class="col-md-2 control-label text-label">Cultural/Stylistic Affiliation</label>
                    <div class="col-md-4">
                        <select class="form-control" v-model="styleDto.culturalAffiliationId" name="culturalAffiliation" v-validate="'required'">
                            <option disabled value="">Select a value</option>
                            <option v-for=" culture in culturalAffiliationList" :value="culture.culturalAffiliationId">
                                {{culture.description}}
                            </option>
                        </select>
                        <span v-show="errors.has('rockArtForm.culturalAffiliation')" class="has-error">{{ errors.first('rockArtForm.culturalAffiliation') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'culturalAffiliationId'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.culturalAffiliationDesc') }">
                    <label class="col-md-2 control-label text-label">Specific affiliation</label>
                    <div class="col-md-4">
                        <label><span>Specific cultural affiliation if known (e.g., Basque)</span></label>
                        <input type="text" class="form-control" v-model="styleDto.culturalAffiliationDesc" name="culturalAffiliationDesc" v-validate="'required'"/>
                        <span v-show="errors.has('rockArtForm.culturalAffiliationDesc')" class="has-error">{{ errors.first('rockArtForm.culturalAffiliationDesc') }}</span>
                    </div>
                    <div class="col-md-2">
                        <label><span>&nbsp;</span></label>
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'culturalAffiliationDesc'" :hasAppend="true"></qaqcFormFieldSelect>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Figure manufacture attributes</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedStyleList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div v-for="t in styleTypeMap" class="checkbox checkbox-inline">
                                <input type="checkbox" v-model="selectedStyleList" :id="qaqcFieldId + t.field" :value="t.field">
                                    <label :for="qaqcFieldId + t.field">{{ t.description}}</label>
                                </input>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.styleComments') }">
                    <label class="col-md-2 control-label text-label">Comments</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control"  v-model="styleDto.styleComments" name="styleComments" v-validate="'required'"/>
                        <span v-show="errors.has('rockArtForm.styleComments')" class="has-error">{{ errors.first('rockArtForm.styleComments') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'styleComments'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">General Classification</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'panelClassificationList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <label><span>Anthropomorphs</span></label>
                        <checkBoxPanel :numColumns="4" :lookupList="panelSymbolList.filter(x=> {return x.isAnthropomorph})" ref="anthropomorphCheckboxPanel" :fieldName="'panelSymbolId'" :name="qaqcFieldId + 'anthropomorphCB'"/>
                        <label><span>Zoomorphs</span></label>
                        <checkBoxPanel :numColumns="4" :lookupList="panelSymbolList.filter(x=> {return x.isZoomorph})" ref="zoomorphCheckboxPanel" :fieldName="'panelSymbolId'" :name="qaqcFieldId + 'zoomorphCB'"/>
                        <div class="form-group">
                            <div class="checkbox checkbox-inline">
                                <input type="checkbox" :id="qaqcFieldId + 'isAbstractCB'" v-model="abstractSymbol">
                                    <label :for="qaqcFieldId + 'isAbstractCB'">Abstracts/Symbols</label>
                                </input>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="checkbox checkbox-inline">
                                <input type="checkbox" :id="qaqcFieldId + 'isNameDateCB'" v-model="nameDatesSymbol">
                                    <label :for="qaqcFieldId + 'isNameDateCB'">Names/Initials/Dates</label>
                                </input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.keywords') }">
                    <label class="col-md-2 control-label text-label">Keywords</label>
                    <div class="col-md-3">
                        <input class="form-control" type="text" v-model="rockArtPanelDto.keywords" name="keywords" v-validate="'required'"/>
                        <span v-show="errors.has('rockArtForm.keywords')" class="has-error">{{ errors.first('rockArtForm.keywords') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'keywords'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.detailedDescription') }">
                    <label class="col-md-2 control-label text-label">Description of panel</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'detailedDescription'" :hasAppend="true"></qaqcFormFieldSelect>
                        <textarea class="form-control" rows="3" v-model="rockArtPanelDto.detailedDescription" name="detailedDescription" v-validate="'required'"/>
                        <span v-show="errors.has('rockArtForm.detailedDescription')" class="has-error">{{ errors.first('rockArtForm.detailedDescription') }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Background</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedBackgroundList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div v-for="b in backgroundMap" class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedBackgroundList" :id="qaqcFieldId + b.field" :value="b.field">
                                <label :for="qaqcFieldId + b.field">{{b.description}}</label>
                            </input>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Rock Feature incorporation</label>
                    <div class="col-md-10">
                        <div class="form-inline">
                            <label><span>Describe natural rock feature incorporation</span></label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'featureIncorporation'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <textarea class="form-control" rows="3" v-model="rockArtPanelDto.featureIncorporation" />
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('rockArtForm.evidenceComment') }">
                    <label class="col-md-2 control-label text-label">Chronological evidence</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedDatingEvidenceList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div v-for="d in datingEvidenceMap" class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedDatingEvidenceList" :id="qaqcFieldId + d.field" :value="d.field">
                                <label :for="qaqcFieldId + d.field">{{d.description}}</label>
                            </input>
                        </div>
                        <input type="text" class="form-control" placeholder="Describe" style="width:600px" v-model="datingEvidenceDto.evidenceComment" name="evidenceComment" v-validate="'required'"/>
                        <span v-show="errors.has('rockArtForm.evidenceComment')" class="has-error">{{ errors.first('rockArtForm.evidenceComment') }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Panel Condition</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedConditionList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div v-for="c in conditionMap" class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedConditionList" :id="qaqcFieldId + c.field + 'c'" :value="c.field">
                                <label :for="qaqcFieldId + c.field + 'c'">{{c.description}}</label>
                            </input>
                        </div>
                        <input type="text" class="form-control" placeholder="Describe" style="width:600px" v-model="rockArtPanelDto.conditionDescription"/>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Concerns/Recommendations</label>
                    <div class="col-md-10">
                        <div class="form-inline">
                            <label><span>PRESERVATION CONCERNS AND CONSERVATION RECOMMENDATIONS</span></label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'preservationConcerns'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <textarea class="form-control" rows="3" v-model="rockArtPanelDto.preservationConcerns" />
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Lighting</label>
                    <div class="col-md-6">
                        <div class="form-inline">
                            <label><span>Best lighting conditions to view panel, if known</span></label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'lightingCondition'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <input type="text" class="form-control" v-model="rockArtPanelDto.lightingCondition"/>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Recordings completed</label>
                    <div class="col-md-6">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedRecordingList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div v-for="r in recordingMap" class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedRecordingList" :id="qaqcFieldId + r.field" :value="r.field">
                            <label :for="qaqcFieldId + r.field">{{r.description}}</label>
                            </input>
                        </div>
                    </div>
                </div>
                <div v-if="!qaqcEnabled" class="form-group">
                    <label class="col-md-2 control-label text-label">File Attachments</label>
                    <div class="col-md-10">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Download</th>
                                    <th>File Name</th>
                                    <th>Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="mediaItem in mediaList">
                                    <td>
                                        <div style="text-align: center;" v-if="mediaItem.mediaId">
                                            <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem)"></a>
                                        </div>
                                    </td>
                                    <td>{{mediaItem.file ? mediaItem.file.name : mediaItem.filename}}</td>
                                    <td>{{mediaItem.comment}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-if="!(formDisabled || qaqcEnabled)" class="form-group">
                    <div class="col-md-3 col-md-offset-2">
                        <input name="newFile" ref="newFile" class="form-control" type="file">
                    </div>
                    <label class="col-md-1 control-label text-label">Comment</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="imageComment">
                    </div>
                    <button class="btn btn-primary col-md-1"  v-on:click="addRockArtFile">Add</button>
                </div>
            </form>
        </fieldset>
        <form class="form-horizontal" v-on:submit.prevent>
            <div class="form-group">
                <hr>
                <div class="row" style='margin-left:10px'>
                    <div class="col-xs-4 text-center">
                        <button class="btn btn-primary" style="margin-left:10px" v-on:click="previousArtPanel" :disabled="currentPanelNumber === 1">Previous</button>
                    </div>
                    <div v-if="!(formDisabled)" class="col-xs-4 text-center">
                        <button class="btn btn-primary" :disabled="formDisabled" v-on:click="qaqcEnabled ? completeSection('rockArt') : saveArtPanel()">Save</button>
                    </div>
                    <div class="col-xs-4 text-center">
                        <button class="btn btn-primary" v-on:click="nextPanel" :disabled="dtoIsNew || currentPanelNumber >= rockArtCount">Next</button>
                    </div>
                </div>
                <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'rockArt'" :completeSection="completeSection"></qaqcFormFieldFooter>
            </div>
        </form>
    </div>
</template>


<script>
import checkBoxPanel from '../CheckBoxPanel.vue'
import rockArtService from '../../services/siteForm/rockArtService'
import loggingService from '../../services/util/loggingService'
import mediaService from '../../services/mediaService'
import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'
import loader from '@/components/Loader.vue'

export default {
    name: 'rockArtForm',
    components: {
        checkBoxPanel,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter,
        loader
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            ageList: [],
            locationList: [],
            culturalAffiliationList: [],
            compassBearingList: [],
            panelSymbolList: [],
            rockArtPanelDto: {},
            orientationDto: {},
            styleDto: {},
            datingEvidenceDto: {},
            styleTypeMap: [],
            backgroundMap: [],
            currentPanelNumber: 1,
            selectedBackgroundList: [],
            selectedDatingEvidenceList: [],
            datingEvidenceMap: [],
            selectedStyleList: [],
            conditionMap: [],
            selectedConditionList: [],
            recordingMap: [],
            selectedRecordingList: [],
            abstractSymbol: false,
            nameDatesSymbol: false,
            mediaList: [],
            imageComment: '',
            existingPanels: 0,
            productionPanelList: []
        }
    },
    props: {
        rockArtCount: {},
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        productionCrrId: { default: null },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no rockArt or rockArtSelection qa/qc objects, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.rockArt || this.qaqcProgressDto.qaqcSelections.rockArt.length === 0) {
                //     this.qaqcProgressDto.qaqcSelections.rockArt = []
                //     for (var i = 0; i < this.rockArtCount; i++) {
                //         this.qaqcProgressDto.qaqcSelections.rockArt.push(qaqcService.rockArtSelection())
                //     }
                // }

                // more selections than counts, remove extras
                if (this.qaqcProgressDto.qaqcSelections.rockArt.length > this.rockArtCount) {
                    let difference = this.qaqcProgressDto.qaqcSelections.rockArt.length - this.rockArtCount
                    for (let i = 0; i < difference; i++) {
                        this.qaqcProgressDto.qaqcSelections.rockArt.pop()
                    }
                }
                // more counts than selections, add more
                if (this.qaqcProgressDto.qaqcSelections.rockArt.length < this.rockArtCount) {
                    let difference = this.rockArtCount - this.qaqcProgressDto.qaqcSelections.rockArt.length
                    for (let i = 0; i < difference; i++) {
                        this.qaqcProgressDto.qaqcSelections.rockArt.push(qaqcService.rockArtSelection())
                    }
                }
                // return the currentPanelNumber's selection in the rockArt array
                return this.qaqcProgressDto.qaqcSelections.rockArt[this.currentPanelNumber - 1] || {}
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        },
        dtoIsNew: function () {
            return !this.rockArtPanelDto.rockArtPanelId || this.rockArtPanelDto.rockArtPanelId === 0
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.isLoading = false
            })
        },
        productionCrrId: function (val) {
            this.log('productionCrrId is changed: ' + val)
            this.loadProductionPanels()
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                if (this.productionCrrId) { this.loadProductionPanels() }
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Art Panel Form', message)
        },
        loadData () {
            var crr = this.crrId
            return rockArtService.search(this.$http, {culturalResourceRecordingId: crr}).then(response => {
                this.loadLookups()
                this.existingPanels = response.data.length
                if (response.data.length > 0) {
                    this.rockArtPanelDto = response.data.find(x => x.panelNumber === this.currentPanelNumber)
                    if (!this.rockArtPanelDto) {
                        this.log('Creating new penel')
                        this.createRockArtPanelDto()
                    } else {
                        var current = response.data.find(x => x.panelNumber === this.currentPanelNumber)
                        this.log(`Current Panel : ${current.rockArtPanelId}`)

                        //Set models to what came back
                        this.rockArtPanelDto = current

                        //set rockArtPanelId to qaqcSelection
                        if (this.qaqcEnabled) {
                            this.qaqcSelection.currentPanelId = this.rockArtPanelDto.rockArtPanelId
                        }
                        this.orientationDto = current.panelOrientationDto
                        this.styleDto = current.panelStyleDto
                        this.datingEvidenceDto = current.panelDatingEvidenceDto

                        // load the selected lists data
                        this.selectedStyleList = this.loadSelectedFieldData(this.styleTypeMap, this.styleDto)
                        this.selectedBackgroundList = this.loadSelectedFieldData(this.backgroundMap, current)
                        this.selectedConditionList = this.loadSelectedFieldData(this.conditionMap, current)
                        this.selectedDatingEvidenceList = this.loadSelectedFieldData(this.datingEvidenceMap, this.datingEvidenceDto)
                        this.selectedRecordingList = this.loadSelectedFieldData(this.recordingMap, current)

                        // extract each panelSymbolId from current.panelClassificationList
                        var currentPanelSymbolId = current.panelClassificationList.map(x => {
                            return x.panelSymbolId
                        })

                        // filter the panelSymbolList to those that are Anthropomorpth/Zoomorpth AND matches panelSymbolId
                        // to the return data.  After filter, map the result to only an array of panelSymbolIds and then
                        // pass to the CheckBoxPanel.selectedList component data
                        this.$refs.anthropomorphCheckboxPanel.selectedList = this.panelSymbolList.filter(x => {
                            return x.isAnthropomorph && currentPanelSymbolId.includes(Number(x.panelSymbolId))
                        }).map(x => {
                            return x.panelSymbolId
                        })

                        this.$refs.zoomorphCheckboxPanel.selectedList = this.panelSymbolList.filter(x => {
                            return x.isZoomorph && currentPanelSymbolId.includes(x.panelSymbolId)
                        }).map(x => {
                            return x.panelSymbolId
                        })
                        this.abstractSymbol = currentPanelSymbolId.includes(22)
                        this.nameDatesSymbol = currentPanelSymbolId.includes(23)

                        mediaService.list(this.$http, mediaService.mediaType.CulturalResourceImages, mediaService.mediaSubtype.RockArtImage, this.rockArtPanelDto.rockArtPanelId).then(result => {
                            this.log(`found ${result.data.length} media items`)
                            this.mediaList = result.data
                            return result
                        })
                    }
                } else {
                    this.log('Creating new penel')
                    this.createRockArtPanelDto()
                }
                return response
            })
        },
        createRockArtPanelDto () {
            this.rockArtPanelDto = {
                culturalResourceRecordingId: this.crrId,
                panelAgeId: '',
                panelLocationId: '',
                panelNumber: this.currentPanelNumber
            }
            this.orientationDto = {
                panelAspectId: '',
                yesNoArcheologicalDepositsId: ''
            }
            this.styleDto = {
                culturalAffiliationId: ''
            }
            this.abstractSymbol = false
            this.nameDatesSymbol = false
            this.datingEvidenceDto = {}
            this.selectedBackgroundList = []
            this.selectedDatingEvidenceList = []
            this.selectedConditionList = []
            this.selectedRecordingList = []
            this.selectedStyleList = []
            this.$refs.anthropomorphCheckboxPanel.selectedList = []
            this.$refs.zoomorphCheckboxPanel.selectedList = []
        },
        loadLookups () {
            this.ageList = rockArtService.getPanelAgeList()
            this.locationList = rockArtService.getPanelLocationList()
            this.culturalAffiliationList = rockArtService.getCulturalAffiliationList()
            this.panelSymbolList = rockArtService.getPanelSymbolList()
            this.compassBearingList = rockArtService.getCompassBearingList()
            this.styleTypeMap = [
                {field: 'isPeckedSolid', description: 'Pecked Solid'},
                {field: 'isOutlinedPecked', description: 'Outlined Pecked'},
                {field: 'isStipplePecked', description: 'Stipple Pecked'},
                {field: 'isIncised', description: 'Incised'},
                {field: 'isScratched', description: 'Scratched'},
                {field: 'isAbraded', description: 'Abraded'},
                {field: 'isPainted', description: 'Painted'},
                {field: 'other', description: 'Other'}
            ]
            this.backgroundMap = [
                {field: 'isNaturalBackground', description: 'Natural Background'},
                {field: 'isSmokeBlackened', description: 'Smoke Blackened'},
                {field: 'isVarnished', description: 'Varnished'},
                {field: 'otherBackground', description: 'Other'}
            ]
            this.datingEvidenceMap = [
                {field: 'hasObjectsDepicted', description: 'Objects Depicted'},
                {field: 'hasSuperimpositions', description: 'Superimpositions'},
                {field: 'hasVarnish', description: 'Varnish'},
                {field: 'hasWeathering', description: 'Weathering'},
                {field: 'hasDating', description: 'Dating (specify method)'}
            ]
            this.conditionMap = [
                {field: 'hasVandalism', description: 'Vandalism'},
                {field: 'hasOtherDamage', description: 'Other Damage'},
                {field: 'hasLichenCover', description: 'Lichen Cover'},
                {field: 'hasWeathering', description: 'Weathering/Deterioration'}
            ]
            this.recordingMap = [
                {field: 'hasScaledDrawing', description: 'Scaled Drawing'},
                {field: 'hasTracing', description: 'Tracing'},
                {field: 'hasFieldSketch', description: 'Field Sketch'},
                {field: 'hasImages', description: 'Images'}
            ]
        },
        saveArtPanel () {
            this.isLoading = true
            return new Promise((resolve) => {
                this.$validator.validateAll('rockArtForm').then(valResult => {
                    if (valResult) {
                        loggingService.log(this.isDebug, 'RockArtForm', 'saveArtPanel - form validated')
                        //clear out the rest of the dto so we dont duplicate on save
                        this.rockArtPanelDto.panelOrientationDto = {}
                        this.rockArtPanelDto.panelStyleDto = {}
                        this.rockArtPanelDto.panelDatingEvidenceDto = {}
                        this.rockArtPanelDto.panelClassificationList = []

                        this.conditionMap.forEach(condition => {
                            this.rockArtPanelDto[condition.field] = this.selectedConditionList.includes(condition.field)
                        })
                        this.backgroundMap.forEach(background => {
                            this.rockArtPanelDto[background.field] = this.selectedBackgroundList.includes(background.field)
                        })
                        this.recordingMap.forEach(recording => {
                            this.rockArtPanelDto[recording.field] = this.selectedRecordingList.includes(recording.field)
                        })
                        this.datingEvidenceMap.forEach(evidence => {
                            this.datingEvidenceDto[evidence.field] = this.selectedDatingEvidenceList.includes(evidence.field)
                        })
                        this.rockArtPanelDto.panelDatingEvidenceDto = this.datingEvidenceDto

                        this.styleTypeMap.forEach(type => {
                            this.styleDto[type.field] = this.selectedStyleList.includes(type.field)
                        })
                        this.rockArtPanelDto.panelStyleDto = this.styleDto

                        var panelSymbolList = this.$refs.anthropomorphCheckboxPanel.selectedList.concat(this.$refs.zoomorphCheckboxPanel.selectedList)
                        if (this.abstractSymbol) {
                            panelSymbolList.push(22)
                        }
                        if (this.nameDatesSymbol) {
                            panelSymbolList.push(23)
                        }
                        this.rockArtPanelDto.panelClassificationList = panelSymbolList.map(x => {
                            return {panelSymbolId: x}
                        })
                        this.rockArtPanelDto.panelOrientationDto = this.orientationDto
                        rockArtService.put(this.$http, this.rockArtPanelDto).then(result => {
                            this.rockArtPanelDto.rockArtPanelId = result.data.objectList[0].rockArtPanelId
                            var panelId = result.data.objectList[0].rockArtPanelId
                            var handle = this
                            var promises = []
                            this.mediaList.forEach(rockArtFile => {
                                if (rockArtFile.file) {
                                    var newPromise = mediaService.putFile(
                                        handle.$http,
                                        mediaService.mediaType.CulturalResourceImages,
                                        mediaService.mediaSubtype.RockArtImage,
                                        panelId,
                                        rockArtFile.file,
                                        rockArtFile.comment)
                                    promises.push(newPromise)
                                }
                            })
                            //Run through each save
                            Promise.all(promises).then(fileUploadResults => {
                                this.log('done saving files')
                                this.loadData()
                                this.isLoading = false
                                resolve(result)
                            })
                        })
                    } else {
                        loggingService.log(this.isDebug, 'RockArtForm', 'saveArtPanel - invalid form')
                        this.isLoading = false
                        resolve(1)
                        //alert('invalid form')
                    }
                })
            })
        },
        previousArtPanel () {
            --this.currentPanelNumber
            this.loadData().then(x => {
                this.errors.clear('rockArtForm')
            })
        },
        nextPanel () {
            ++this.currentPanelNumber
            this.loadData().then(x => {
                this.errors.clear('rockArtForm')
            })
        },
        addRockArtFile () {
            if (this.imageComment) {
                this.log('Number of files:' + this.$refs['newFile'].files.length + ', Name: ' + this.$refs['newFile'].files[0].name)
                this.mediaList.push({file: this.$refs['newFile'].files[0], comment: this.imageComment})
                this.$refs['newFile'].value = ''
                this.imageComment = ''
            }
        },
        loadSelectedFieldData (fieldMap, data) {
            var selected = []
            fieldMap.forEach(f => {
                if (data[f.field]) {
                    selected.push(f.field)
                }
            })
            return selected
        },
        checkSelectionComplete (selection) {
            for (let key in selection) {
                if ((String(key) === 'panelSelection' && selection[key] === -1) || (String(key) !== 'panelSelection' && selection[key] === 0)) {
                    return false
                }
            }
            return true
        },
        completeSection (sectionName) {
            // set the consolidated selection fields
            this.qaqcSelection.heightTop = this.qaqcSelection.heightBottom
            this.qaqcSelection.panelWidth = this.qaqcSelection.panelHeight
            this.qaqcSelection.panelDegree = this.qaqcSelection.panelDistance

            //set the current panelId to selection
            this.saveArtPanel().then(response => {
                if (!this.rockArtPanelDto.rockArtPanelId) {
                    alert('Rock Art Panel has not been saved. Cannot complete section.')
                    return
                }
                this.qaqcSelection.currentPanelId = this.rockArtPanelDto.rockArtPanelId
                //check if all selections have been made
                if (this.qaqcSelection.panelSelection === -1) {
                    alert('Please complete Panel Selection')
                    return
                }
                if (!this.checkSelectionComplete(this.qaqcSelection)) {
                    alert('Please complete all QA/QC selections in this section.')
                    return
                }
                var sectionComplete = true
                //check if the other rockArt panel selections have been complete
                this.qaqcProgressDto.qaqcSelections.rockArt.forEach(selection => {
                    if (!this.checkSelectionComplete(selection)) { sectionComplete = false }
                })

                this.saveQaqcProgress(sectionName, sectionComplete)
            })
        },
        loadProductionPanels () {
            this.productionPanelList = []
            return rockArtService.search(this.$http, {culturalResourceRecordingId: this.productionCrrId}).then(result => {
                result.data.forEach(panel => {
                    this.productionPanelList.push(panel)
                })
            })
        },
        mediaDownloadRow (mediaItem) {
            mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                mediaService.saveFileToDownload(response, mediaItem.filename)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// RockArtForm.vue?7873e131